(function () {
  if (customElements.get('rf-delivered-price')) return;

  var STYLE_KEYS = [
    'backgroundColor', 'color',
    'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
    'borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle',
    'borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor',
    'borderTopLeftRadius', 'borderTopRightRadius',
    'borderBottomLeftRadius', 'borderBottomRightRadius',
    'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
    'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'letterSpacing'
  ];

  function formatMoney(cents, sample) {
    var withDecimals = String(sample).match(/123(\D)45/);
    if (withDecimals) {
      var amount = (cents / 100).toFixed(2).replace('.', withDecimals[1]);
      return String(sample).replace(withDecimals[0], amount);
    }
    if (/123/.test(sample)) return String(sample).replace('123', String(Math.round(cents / 100)));
    return (cents / 100).toFixed(2);
  }

  class RfDeliveredPrice extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.lang = this.dataset.lang === 'de' ? 'de' : 'en';
      this.nudgeSlot = this.querySelector('[data-rf-dp-nudge]');

      try {
        this.variants = JSON.parse(this.querySelector('[data-rf-dp-variants]').textContent);
      } catch (e) {
        this.variants = {};
      }

      this.country = String(this.dataset.country || '').toUpperCase();
      this.signature = '';

      var self = this;

      this.onChange = function (event) {
        var t = event.target;
        if (t && t.classList && t.classList.contains('rf-vt__radio')) {
          setTimeout(function () { self.render(); }, 0);
        }
      };
      document.addEventListener('change', this.onChange);
      this.onInput = function () { setTimeout(function () { self.check(); }, 0); };
      document.addEventListener('input', this.onInput);

      // Pagespeed V4: safety-net poll, 1x per second and paused in background tabs (events handle instant updates)
      this.poll = setInterval(function () { if (!document.hidden) self.check(); }, 1000);

      this.onCart = function () { self.signature = ''; self.check(); };
      document.addEventListener('rf:cart-changed', this.onCart);

      var tiers = this.tiers;
      if (tiers) {
        try {
          this.mo = new MutationObserver(function () { self.render(); });
          this.mo.observe(tiers, { subtree: true, attributes: true, attributeFilter: ['data-total'] });
        } catch (e) {}
      }

      if (typeof window.rfGetCountry === 'function') {
        window.rfGetCountry(this.dataset.country, this.dataset.designMode)
          .then(function (code) { self.setCountry(code || self.dataset.country); })
          .catch(function () { self.setCountry(self.dataset.country); });
      } else {
        this.setCountry(this.dataset.country);
      }
    }

    disconnectedCallback() {
      clearInterval(this.poll);
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('input', this.onInput);
      document.removeEventListener('rf:cart-changed', this.onCart);
      if (this.mo) this.mo.disconnect();
    }

    setCountry(code) {
      this.country = String(code || '').toUpperCase();
      this.signature = '';
      this.render();
    }

    /* ---------- Sources ---------- */

    get tiers() {
      return (this.section || document).querySelector('rf-volume-tiers');
    }

    get shipData() {
      if (this._shipData) return this._shipData;
      if (window.rfShipData) { this._shipData = window.rfShipData; return this._shipData; }
      var scope = this.section || document;
      var node = scope.querySelector('rf-shipping script[data-rf-ship-data]')
              || document.querySelector('rf-shipping script[data-rf-ship-data]');
      if (node) {
        try { this._shipData = JSON.parse(node.textContent); } catch (e) { this._shipData = null; }
      }
      return this._shipData;
    }

    get shipBox() {
      return (this.section || document).querySelector('rf-shipping')
          || document.querySelector('rf-shipping');
    }

    /* Cart and setting both come from the shipping box so the two can
       never calculate differently. */
    get cart() {
      var box = this.shipBox;
      return (box && box.cart) || null;
    }

    get includeCart() {
      var box = this.shipBox;
      return !!box && box.dataset.includeCart === 'true';
    }

    get qtyInput() {
      var scope = this.section || document;
      return scope.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    }

    get qty() {
      var t = this.tiers;
      if (t) {
        var checked = t.querySelector('.rf-vt__radio:checked');
        if (checked) return parseInt(checked.value, 10) || 1;
      }
      var input = this.qtyInput;
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    }

    /* The amount that goes into the cart: the tile, or more via the stepper. */
    get realQty() {
      var input = this.qtyInput;
      var fromInput = parseInt(input && input.value, 10) || 0;
      return Math.max(this.qty, fromInput);
    }

    get variantId() {
      var scope = this.section || document;
      var input = scope.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] [name="id"]');
      if (input && this.variants[input.value]) return String(input.value);
      return String(this.dataset.variantId);
    }

    get rate() {
      var c = window.Shopify && window.Shopify.currency;
      if (c && c.active && c.active !== this.dataset.shopCurrency && parseFloat(c.rate) > 0) {
        return parseFloat(c.rate);
      }
      return 1;
    }

    money(cents) {
      return formatMoney(cents, this.dataset.moneySample || '');
    }

    green() {
      if (this._green) return this._green;
      var tiers = this.tiers;
      var pill = tiers && tiers.querySelector('.rf-vt__discount');
      if (pill) {
        var bg = window.getComputedStyle(pill).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') this._green = bg;
      }
      return (this._green = this._green || (this.dataset.green || '#1a7f37'));
    }

    /* ---------- Calculation ---------- */

    /* The subtotal comes from the shipping box, never from this block.
       rf-shipping.scenario() already handles the volume tiers, the cart,
       cart level discount codes, per order caps and the rounding checkout
       uses. Recalculating any of that here is what made the two numbers
       disagree, so the only job left is turning the scenario into a rate. */
    quote(qty) {
      var data = this.shipData;
      var c = data && data.countries ? data.countries[this.country] : null;
      if (!c) return null;
      if (!window.rfShipCore || typeof window.rfShipCore.quote !== 'function') return null;

      var box = this.shipBox;
      if (!box || typeof box.scenario !== 'function') return null;

      var sc;
      try {
        sc = box.scenario(qty);
      } catch (e) {
        /* The shipping box exists but is not upgraded yet. The poll retries. */
        return null;
      }
      if (!sc || !sc.grams) return null;

      var rate = this.rate;
      var list = window.rfShipCore.quote(c, sc.grams, Math.round(sc.subtotal / rate));
      if (!list || !list.length) return null;

      return {
        cents: Math.round(list[0].cents * rate),
        subtotal: sc.subtotal,
        dap: c.dap === 1
      };
    }

    /* ---------- DOM ---------- */

    /* Wrap the two price nodes in their own row so our line fits below
       without touching the existing flex rule. */
    priceBox() {
      var t = this.tiers;
      var prices = t && t.querySelector('.rf-vt__summary-prices');
      if (!prices) return null;

      var row = prices.querySelector(':scope > .rf-dp-pricerow');
      if (!row) {
        var cs = window.getComputedStyle(prices);
        var gap = cs.columnGap && cs.columnGap !== 'normal' ? cs.columnGap : '8px';
        row = document.createElement('div');
        row.className = 'rf-dp-pricerow';
        row.style.display = 'flex';
        row.style.flexWrap = 'wrap';
        row.style.justifyContent = 'flex-end';
        row.style.alignItems = cs.alignItems && cs.alignItems !== 'normal' ? cs.alignItems : 'baseline';
        row.style.columnGap = gap;
        while (prices.firstChild) row.appendChild(prices.firstChild);
        prices.appendChild(row);
        prices.style.display = 'block';
        prices.style.textAlign = 'right';
      }

      var line = prices.querySelector(':scope > .rf-dp-line');
      if (!line) {
        line = document.createElement('span');
        line.className = 'rf-dp-line';
        prices.appendChild(line);
      }

      var note = prices.querySelector(':scope > .rf-dp-note');
      if (!note) {
        note = document.createElement('span');
        note.className = 'rf-dp-note';
        prices.appendChild(note);
      }

      return { line: line, note: note };
    }

    tierLine(card) {
      var line = card.querySelector(':scope > .rf-dp-tier');
      if (!line) {
        line = document.createElement('span');
        line.className = 'rf-dp-tier';
        card.appendChild(line);
      }
      return line;
    }

    check() {
      var t = this.tiers;
      var checked = t && t.querySelector('.rf-vt__radio:checked');
      var cart = this.cart;
      var sig = [
        this.country,
        this.variantId,
        checked ? checked.value : '',
        checked ? checked.dataset.total : '',
        this.realQty,
        cart ? cart.token : '',
        cart ? cart.item_count : '',
        cart ? cart.total_price : '',
        this.nudgeText()
      ].join('|');
      if (sig === this.signature) return;
      this.signature = sig;
      this.render();
    }

    nudgeText() {
      var src = document.querySelector('rf-shipping [data-rf-nudge]');
      if (!src || src.hidden) return '';
      var txt = src.textContent ? src.textContent.trim() : '';
      return txt;
    }

    renderNudge() {
      if (!this.nudgeSlot) return;

      if (this.dataset.showNudge !== 'true') {
        this.nudgeSlot.hidden = true;
        return;
      }

      var txt = this.nudgeText();
      if (!txt) {
        this.nudgeSlot.hidden = true;
        this.nudgeSlot.textContent = '';
        return;
      }

      if (this.nudgeSlot.textContent !== txt) this.nudgeSlot.textContent = txt;
      this.nudgeSlot.hidden = false;

      /* Adopt the styling from the shipping box, even when it is hidden. */
      var src = document.querySelector('rf-shipping [data-rf-nudge]');
      if (!src) return;
      try {
        var prev = src.style.display;
        src.style.setProperty('display', 'block', 'important');
        var cs = window.getComputedStyle(src);
        for (var i = 0; i < STYLE_KEYS.length; i++) {
          var k = STYLE_KEYS[i];
          if (cs[k]) this.nudgeSlot.style[k] = cs[k];
        }
        this.nudgeSlot.style.textAlign = 'center';
        src.style.display = prev;
      } catch (e) {}
    }

    render() {
      try { this.renderNudge(); } catch (e) { if (window.console) console.warn('[rf-delivered-price] nudge', e); }

      if (this.dataset.showTotal !== 'true') return;

      if (!window.rfShipCore || !this.shipData) {
        if (!this._warned && window.console) {
          this._warned = true;
          console.warn('[rf-delivered-price] rf-shipping not found: no rate table, no delivered line.');
        }
        return;
      }

      /* No quantity picker, no delivered line. Without volume tiers there is
         nothing to compare, and the shipping box right above already states
         the rate. Ultimate Box, Trial Pack and TRAIN & RACE land here. */
      var t = this.tiers;
      if (!t) return;

      var radios = t.querySelectorAll('.rf-vt__radio');
      if (!radios.length) return;

      var v = this.variants[this.variantId] || [0, 0];
      var price = parseInt(v[0], 10) || 0;
      if (!price) return;

      var self = this;
      /* 24 Oct 2026: the 3 box tile counts along with the stepper (4, 5 ... boxes, renderHead in
         assets/rf-volume-tiers.js), so its free shipping is quoted for that amount, the same amount the
         shipping box below quotes. Tiles 1 and 2 stay their own amount. */
      var input = this.qtyInput;
      var stepQty = parseInt(input && input.value, 10) || 0;

      for (var i = 0; i < radios.length; i++) {
        (function (radio) {
          var qty = parseInt(radio.value, 10) || 1;
          if (qty === 3) qty = Math.max(3, stepQty);
          var card = radio.closest('.rf-vt__option');
          if (!card) return;

          var q = self.quote(qty);
          var tl = self.dataset.showTier === 'true' ? self.tierLine(card) : card.querySelector(':scope > .rf-dp-tier');

          if (!q) {
            if (tl) { tl.hidden = true; tl.textContent = ''; }
            radio.dataset.rfDelivered = '';
            radio.dataset.rfFree = '';
            radio.dataset.rfDap = '';
            return;
          }

          var free = q.cents === 0;
          /* 20 Oct 2026: the free shipping mark on the tiles waits for the cart. Before the shipping box has
             loaded it (until then it holds a placeholder without a token), the quote counts an empty cart and took
             the mark off "1 Box" for about a second; the server already rendered it with the cart included
             (blocks/volume-tiers.liquid). */
          if (!self.includeCart || (self.cart && self.cart.token)) card.classList.toggle('rf-vt__option--free', free);

          if (tl) {
            if (free || self.dataset.showTier !== 'true') {
              tl.hidden = true;
              tl.textContent = '';
            } else {
              tl.hidden = false;
              tl.textContent = '+ ' + self.money(q.cents);
            }
          }

          radio.dataset.rfDelivered = self.money(q.subtotal + q.cents);
          radio.dataset.rfFree = free ? '1' : '';
          radio.dataset.rfDap = q.dap ? '1' : '';
        })(radios[i]);
      }

      var checked = t.querySelector('.rf-vt__radio:checked');
      var box = this.priceBox();
      if (!box || !checked) return;

      /* "More than 3 boxes" (Oct 2026): the 3 box tile stays checked while the
         stepper sets 4, 5, ... boxes in the quantity field. The line under the
         total must quote that amount, not the tile's 3 boxes. */
      var cur = { rfDelivered: checked.dataset.rfDelivered, rfFree: checked.dataset.rfFree };
      var real = this.realQty;
      if (real > (parseInt(checked.value, 10) || 1)) {
        var qr = this.quote(real);
        cur = qr ? { rfDelivered: this.money(qr.subtotal + qr.cents), rfFree: qr.cents === 0 ? '1' : '' } : { rfDelivered: '', rfFree: '' };
      }

      var line = box.line;
      var cart = this.includeCart ? this.cart : null;
      var hasCart = !!(cart && cart.item_count > 0);
      box.note.hidden = !hasCart || !cur.rfDelivered;
      box.note.textContent = hasCart ? this.dataset.tCartnote : '';

      /* Free shipping is already called out on the quantity tile, so the line
         under the total just says "incl. shipping" in the usual muted grey. */
      if (cur.rfFree === '1') {
        line.hidden = false;
        line.textContent = this.dataset.tDelivered;
        line.classList.remove('rf-dp-line--free');
        line.style.color = '';
        return;
      }

      line.classList.remove('rf-dp-line--free');
      line.style.color = '';

      var d = cur.rfDelivered;
      if (!d) {
        line.hidden = true;
        line.textContent = '';
      } else {
        line.hidden = false;
        line.textContent = d + ' ' + this.dataset.tDelivered;
      }
    }
  }

  customElements.define('rf-delivered-price', RfDeliveredPrice);
})();

